import {
  ChannelsApi,
  Configuration,
  MessagesApi,
  UsersApi,
  type ConfigurationParameters,
} from '@teemill/chat';
import { ProjectsApi, Configuration as ProjectsConfiguration } from '@teemill/projects';
import type { App } from 'vue';

export let channels: ChannelsApi;
export let messages: MessagesApi;
export let users: UsersApi;
export let projectsClient: ProjectsApi;

export let errorHandler: (e: any) => void;

export const chat = {
  install(
    app: App,
    options: {
      client: ConfigurationParameters;
      errorHandler: (e: any) => void;
    },
  ) {
    channels = new ChannelsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    messages = new MessagesApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    users = new UsersApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );

    projectsClient = new ProjectsApi(
      new ProjectsConfiguration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );

    errorHandler = options.errorHandler || ((e) => console.error(e));
  },
};
